import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "padding": "20px 24px"
  }
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "An invite has been sent to new member(s).", -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " The new member will able to join the workspace by clicking on the URL in the email sent. ", -1);
const _hoisted_5 = [_hoisted_3, _hoisted_4];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_input_range = _resolveComponent("app-input-range");
  const _component_app_form = _resolveComponent("app-form");
  const _component_custom_side_bar_app_modal = _resolveComponent("custom-side-bar-app-modal");
  return _openBlock(), _createBlock(_component_custom_side_bar_app_modal, {
    modelValue: $options.modal,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $options.modal = $event),
    "ok-loading": $props.loading,
    "no-cancel": $props.inviteSent,
    "ok-title": $props.inviteSent ? 'Ok' : 'Invite',
    title: "Add Member",
    onOk: $options.onSubmit
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [$props.inviteSent ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5)) : (_openBlock(), _createBlock(_component_app_form, {
      key: 1,
      novalidate: "",
      onSubmit: $options.onSubmit
    }, {
      default: _withCtx(() => [_createElementVNode("p", null, " Invite a new member to the workspace " + _toDisplayString(this.workspace?.workspace_name) + " with an email ", 1), _createVNode(_component_app_input_range, {
        modelValue: $data.form.members,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.members = $event),
        validateRule: "email",
        type: "email",
        label: "Members",
        placeholder: "Please enter an email",
        onSubmit: $options.onSubmit
      }, null, 8, ["modelValue", "onSubmit"])]),
      _: 1
    }, 8, ["onSubmit"]))])]),
    _: 1
  }, 8, ["modelValue", "ok-loading", "no-cancel", "ok-title", "onOk"]);
}